namespace Matrix.Workflow {
    export namespace ClientFunctionTriggerService {
        export const baseUrl = 'Workflow/ClientFunctionTrigger';

        export declare function Create(request: Serenity.SaveRequest<ClientFunctionTriggerRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ClientFunctionTriggerRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ClientFunctionTriggerRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ClientFunctionTriggerRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Workflow/ClientFunctionTrigger/Create",
            Update = "Workflow/ClientFunctionTrigger/Update",
            Delete = "Workflow/ClientFunctionTrigger/Delete",
            Retrieve = "Workflow/ClientFunctionTrigger/Retrieve",
            List = "Workflow/ClientFunctionTrigger/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ClientFunctionTriggerService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
